import React, { useContext } from 'react';
import cn from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { elmoSaysThisMightBeADeviationUrl } from '../../../utils/deviations';

import s from './DeviationLink.scss';

export interface Props {
  className?: string;
  style?: React.CSSProperties;
  link?: string;
  deviation: PapiDeviation;
  children: any;
}

function isInternalLink(url) {
  return (
    /^https:\/\/www\.deviantart\.com/.test(url) ||
    /^#/.test(url) ||
    elmoSaysThisMightBeADeviationUrl(url)
  );
}

export function findAndScrollTo(id, isMobile) {
  const el = document.getElementById(id.replace(/^#/, ''));
  if (el) {
    scrollIntoViewWithHeader(el, isMobile, undefined, undefined, true, true);
  }
}

const getUrl = url => {
  if (!url) {
    return url;
  }
  if (!/^https?/.test(url)) {
    return `https://${url}`;
  }
  return url;
};

const EditorDeviationLink: React.FC<Props> = ({
  className,
  style,
  link,
  deviation,
  children,
}) => {
  const isMobile = useContext(MobileContext);

  const linkProps = {
    className: cn(s['link'], className),
    style,
  };

  if (link) {
    link = link.trim();
    if (/^#[a-z-0-9]+$/i.test(link)) {
      return (
        <a
          {...linkProps}
          href={link}
          onClick={e => {
            e.preventDefault();
            findAndScrollTo(link, isMobile);
          }}
          rel="noopener ugc noreferrer"
        >
          {children}
        </a>
      );
    }
    return (
      <a
        {...linkProps}
        href={getUrl(cleanLinkSrc(link))}
        rel="noopener ugc noreferrer"
        target={
          isInternalLink(getUrl(cleanLinkSrc(link))) ? undefined : '_blank'
        }
      >
        {children}
      </a>
    );
  }

  return (
    <DeviationLink
      {...linkProps}
      deviation={deviation}
      canLinkToStash={deviation.isJournal}
    >
      {children}
    </DeviationLink>
  );
};
EditorDeviationLink.displayName = 'EditorDeviationLink';

export default EditorDeviationLink;
